export default __webpack_public_path__ + "static/media/almani-qhizq_V876M-unsplash.1b8ca75c.jpg";